/**
* Model import Example :
* import { HERO } from '../models/hero.model.ts';
*/
var ccComponent = (function () {
    function ccComponent() {
        this.alert_data = [
            {
                "name": "Super Sport",
                "sl": {
                    "name": "Service Level",
                    "value": "100.00%"
                },
                "cw": {
                    "name": "Call Waiting",
                    "value": 0
                },
                "data": [{
                        "name": "Offered",
                        "value": 14
                    }, {
                        "name": "Handled",
                        "value": 12
                    }, {
                        "name": "Abandoned",
                        "value": 0
                    }]
            }
        ];
        this.data = {
            "sl": {
                "name": "Service Level",
                "data": [{
                        "name": "Service Level",
                        "value": "99%"
                    }]
            },
            "clwt": {
                "name": "Current Longest Call Waiting",
                "data": [{
                        "name": "Current Longest Call Waiting",
                        "value": "00:00:00:"
                    }]
            },
            "call_stat": {
                "name": "Call Statistics",
                "data": [
                    {
                        "name": "Calls in Queue",
                        "value": "0"
                    },
                    {
                        "name": "Average Speed of Answer",
                        "value": "00:00:09"
                    }
                ]
            },
            "agent_stat": {
                "name": "Agent Statistics",
                "data": [
                    {
                        "name": "Agents Acive",
                        "value": 278
                    },
                    {
                        "name": "Agents Idle",
                        "value": 52
                    },
                    {
                        "name": "Agents not Ready",
                        "value": 3
                    },
                    {
                        "name": "Agents inbound",
                        "value": 356
                    },
                    {
                        "name": "Agents Outbound",
                        "value": 0
                    },
                    {
                        "name": "Average Talk Time",
                        "value": "00:06:17"
                    },
                    {
                        "name": "Average Handle Time",
                        "value": "00:06:37"
                    }
                ]
            }
        };
    }
    ccComponent.prototype.ngOnInit = function () {
    };
    ccComponent.prototype.optionClick = function (clickedOption) {
        // console.log(clickedOption);
    };
    return ccComponent;
}());
export { ccComponent };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/ccComponent/cc.component.ts.pre-build-optimizer.js